import type { DefaultTheme } from "styled-components";

import {
  resolveCollectionFrameRecipe,
  resolveCollectionRowRecipe,
  resolveCollectionRowSurface,
} from "../foundations/collectionAppearance";
import type { ListViewAppearance, ListViewRowAppearance } from "./ListView";

export function resolveListViewAppearanceRecipe(
  theme: DefaultTheme,
  appearance: ListViewAppearance,
  rowAppearance: ListViewRowAppearance,
) {
  const frame = resolveCollectionFrameRecipe(theme, appearance);
  const row = resolveCollectionRowRecipe(theme, rowAppearance);

  // framed/continuous는 Studio의 연속된 elevated 목록 면이다. 톤만 높이고
  // continuous의 radius·divider·행 배치 계약은 그대로 사용한다.
  if (appearance === "framed" && rowAppearance === "continuous") {
    return {
      frame: { ...frame, surface: theme.color.bg.surfaceRaised },
      row: { ...row, surface: resolveCollectionRowSurface(theme, "raised") },
    };
  }

  return { frame, row };
}
